import { doc, updateDoc } from "firebase/firestore";
import { db } from "../Firebase/firebase";

const deleteItems = async (prodId, userId, realTimeData) => {
  const docRef = doc(db, "users", userId);
  const newCart = realTimeData.cart.filter((item) => item.pId !== prodId);
  await updateDoc(docRef, {
    cart: newCart,
  });
};

export default deleteItems;
